import { getPaymentTypes } from 'services/ErplyAPI';
import * as actionTypes from 'constants/Payments';
import { savePaymentType } from 'services/ErplyAPI/payment';

// eslint-disable-next-line import/prefer-default-export
export const getPaymentTypesAction = params => async dispatch => {
  const payload = await getPaymentTypes(params).then(data => data);
  dispatch({
    type: actionTypes.GET_PAYMENT_TYPES,
    payload,
  });
};

export const createPaymentType = (params = {}) => async dispatch => {
  await savePaymentType({ ...params });
  dispatch(getPaymentTypesAction());
};
